import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { SocketContext } from "../../../context/Socket/SocketContext";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { i18n } from "../../../translate/i18n";
import { useTheme } from "@material-ui/core/styles";
import { isDarkTheme } from "../../../helpers/darkTint";

// props.pix: { qr_code, qr_code_base64, amount } (Pix do Mercado Pago)
function CheckoutSuccess(props) {

  const { pix } = props;
  const pixString = pix?.qr_code || "";
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();
  const theme = useTheme();

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const onPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        toast.success(
          i18n.t("checkout.success.licenseRenewed", {
            date: dateToClient(data.company.dueDate),
          })
        );
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    };

    socket.on(`company-${companyId}-payment`, onPayment);

    return () => {
      socket.off(`company-${companyId}-payment`, onPayment);
    };
  }, [history, socketManager, dateToClient]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  return (
    <React.Fragment>
      <Total $darkColor={isDarkTheme(theme) ? theme.palette.text.primary : undefined}>
        <span>TOTAL</span>
        <strong>{Number(pix?.amount || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
      </Total>
      <SuccessContent>
        {pix?.qr_code_base64 ? (
          <img
            src={`data:image/png;base64,${pix.qr_code_base64}`}
            alt={i18n.t("checkout.success.qrAlt")}
            style={{ width: 256, height: 256 }}
          />
        ) : (
          <QRCode value={pixString} />
        )}
        <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
          <button className="copy-button" type="button">
            {copied ? (
              <>
                <span>{i18n.t("checkout.success.copied")}</span>
                <FaCheckCircle size={18} />
              </>
            ) : (
              <>
                <span>{i18n.t("checkout.success.copyPixCode")}</span>
                <FaCopy size={18} />
              </>
            )}
          </button>
        </CopyToClipboard>
        <span>{i18n.t("checkout.success.instructions")}</span>
      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
